import React, { useState } from 'react'
import { Panel, Row, Col, ControlLabel, SelectPicker, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { downloadFile } from '../../utils/fileUtil'
import {
  downloadBorrowReportExport,
  getBorrowReportPdf,
} from '../../redux/actions/accountingReport'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import PreviewButton from '../../components/buttons/previewButton/PreviewButton'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import { REQUEST_DATE_FORMAT } from '../../constants/date'

export default function BorrowAvanceReportWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)

  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  const projectCode = sessionStorage.getItem('projectCode')

  const handleOnExport = async (data) => {
    // console.log('handleOnExport ', data)

    setIsLoading(true)
    startLoading()
    try {
      const sdate = startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : ''
      const edate = endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : ''

      const file = await downloadBorrowReportExport(projectCode, data.periodOption, sdate, edate)

      // console.log('file ', file)
      if (file) {
        downloadFile(file, `รายงานเงินยืมทดรองจ่าย.xlsx`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnSearch = async (data) => {
    console.log('handleOnExport ', data)

    startLoading()
    setIsPdfError(false)
    setIsLoading(true)
    setIsLoadingPDF(true)
    try {
      const sdate = startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : ''
      const edate = endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : ''

      const response = await getBorrowReportPdf(projectCode, data.periodOption || '', sdate, edate)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.log('error ', e)
      setIsPdfError(true)
    }
    setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel
        shaded
        collapsible
        defaultExpanded
        header={formSchema?.form?.header || 'รายงานเงินยืมทดรองจ่าย'}
        bordered
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setVoucherSchema(null)
          setPeriodicSchema(null)
        }}
      >
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        <br />

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <div style={{ marginTop: 10 }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema.form.periodOption.validators,
                  formSchema.form.periodOption.label
                )}
              </ControlLabel>
            </div>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <div style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[formSchema.form.periodOption.name]} />
              <Controller
                name={formSchema.form.periodOption.name}
                control={control}
                defaultValue={formSchema.form.periodOption.value}
                rules={isValidators(formSchema.form.periodOption.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      searchable={false}
                      data={formSchema.form.periodOption.options}
                      value={props.value}
                      block
                      placeholder={formSchema?.form?.periodOption?.placeholder || ''}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </div>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}></Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          {formSchema?.form?.startDate && (
            <>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {formSchema.form.startDate.label}
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <DatePickerCustom
                  value={startDate}
                  onChange={(value) => {
                    setStartDate(value)
                  }}
                  placement="auto"
                  // disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
                  disabledDate={(date) =>
                    (formSchema?.projectInfo?.projectStartDate &&
                      moment(formSchema.projectInfo.projectStartDate)
                        .startOf('day')
                        .isAfter(date, new Date())) ||
                    (formSchema?.projectInfo?.projectEndDate &&
                      moment(formSchema.projectInfo.projectEndDate)
                        .startOf('day')
                        .add(1, 'days')
                        .isBefore(date, new Date())) ||
                    (endDate && moment(endDate).isBefore(date, new Date()))
                  }
                />
              </Col>
            </>
          )}

          {formSchema?.form?.endDate && (
            <>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {formSchema.form.endDate.label}
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <DatePickerCustom
                  value={endDate}
                  onChange={(value) => {
                    setEndDate(value)
                  }}
                  placement="auto"
                  // disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
                  disabledDate={(date) =>
                    (formSchema?.projectInfo?.projectStartDate &&
                      moment(formSchema.projectInfo.projectStartDate)
                        .startOf('day')
                        .isAfter(date, new Date())) ||
                    (formSchema?.projectInfo?.projectEndDate &&
                      moment(formSchema.projectInfo.projectEndDate)
                        .startOf('day')
                        .add(1, 'days')
                        .isBefore(date, new Date())) ||
                    (startDate && moment(startDate).isAfter(date, new Date()))
                  }
                />
              </Col>
            </>
          )}
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <PreviewButton onClick={handleSubmit(handleOnSearch)}>
              แสดงตัวอย่างก่อนพิมพ์
            </PreviewButton>
            <SaveButton icon="file-excel-o" onClick={handleSubmit(handleOnExport)}>
              Export to MS-Excel
            </SaveButton>
          </Col>
        </Row>

        {previewPdf && (
          <Row>
            {isPdfError ? (
              <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
            ) : (
              <PdfRenderWidgets
                file={previewPdf}
                isLoading={isLoadingPDF}
                isShaded={false}
                onReload={handleSubmit(handleOnSearch)}
                loadingMessage="กรุณารอสักครู่ ระบบกำลังสร้าง PDF"
                fileName="รายงานเงินยืมทดรองจ่าย"
              />
            )}
          </Row>
        )}
      </Panel>
    </>
  )
}
